/**
 * 
 * @param {Array} selects - array/nodelist of option selector elements
 * @returns {Array} - array of options
 */


const getCurrentSelectedOptions = (els) => els.flatMap(el => {
  if (el.tagName === 'SELECT') {
    return [el.value];
  } else if (el.tagName === 'INPUT' && el.getAttribute('type') === 'radio') {
    return el.checked ? [el.value] : [];
  } else if (el.tagName === 'INPUT' && el.getAttribute('type') === 'hidden') {
    return [el.value]
  }
})



export default getCurrentSelectedOptions;